import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

let cached = null;

// Viewlux logo from Settings (public, so the login page and staff see it too).
export function useBrandLogo() {
  const { logoVersion } = useAuth();
  const [url, setUrl] = useState(cached);
  useEffect(() => {
    let alive = true;
    api.get("/brand")
      .then(async (r) => {
        if (!r.data.has_logo) {
          cached = null;
          return alive && setUrl(null);
        }
        const b = await api.get("/brand/logo", { responseType: "blob", params: { v: logoVersion || 0 } });
        cached = URL.createObjectURL(b.data);
        if (alive) setUrl(cached);
      })
      .catch(() => alive && setUrl(null));
    return () => { alive = false; };
  }, [logoVersion]);
  return url;
}

export const Wordmark = ({ to = "/", size = "md", testId = "viewlux-header-logo" }) => {
  const logo = useBrandLogo();
  const lg = size === "lg";
  return (
    <Link to={to} data-testid={testId} className="group inline-flex items-center">
      {logo ? (
        <img src={logo} alt="Viewlux" data-testid={`${testId}-image`} className={`${lg ? "h-14 max-w-[240px]" : "h-9 max-w-[170px]"} object-contain`} />
      ) : (
        <span data-testid={`${testId}-wordmark`} className="flex flex-col items-stretch leading-none">
          <span className={`font-brand ${lg ? "text-3xl" : "text-xl"} font-semibold tracking-[0.3em] text-slate-50 max-sm:text-base`}>VIEWLUX</span>
          <span className="mt-1.5 h-px w-full bg-gold transition-transform duration-500 group-hover:scale-x-90" />
          <span className={`mt-1.5 ${lg ? "text-[10px]" : "hidden text-[7.5px] sm:block"} whitespace-nowrap font-medium tracking-[0.45em] text-amber-500`}>WINDOWS AND DOORS</span>
        </span>
      )}
    </Link>
  );
};
